module.exports = __webpack_public_path__ + "static/media/svg-1.18c89737.svg";